// extracted by mini-css-extract-plugin
export default {"position":"Nav_position__NUEr9","button":"Nav_button__BLKiY","button2x":"Nav_button2x__tJmbE","button3x":"Nav_button3x__WQxZ6"};